import styled, { css } from 'styled-components';
import { generateMediaQueries, generateMediaQueriesForGutterValue } from '../utilities';
var baseStackCSS = css(["display:flex;flex-direction:column;flex-wrap:nowrap;height:auto;width:100%;box-sizing:border-box;"]);
var GridRow = styled.div.withConfig({
  displayName: "Rowstyles__GridRow",
  componentId: "sc-1w6itvg-0"
})(["", " ", " ", " ", " ", " ", ""], baseStackCSS, function (props) {
  return props.gutterValue === 1 && css(["padding-right:calc(", " / 2);margin-left:calc(-", " / 2);"], props.gutterSize, props.gutterSize);
}, function (props) {
  return props.alignItems && css(["align-items:", ";"], props.alignItems);
}, function (props) {
  return props.justifyContent && css(["justify-content:", ";"], props.justifyContent);
}, function (props) {
  return generateMediaQueries(props);
}, function (props) {
  return generateMediaQueriesForGutterValue(props);
});
export { GridRow };